import apiService from './apiService';
import { setRuntimeUserRoles } from '../config/userRoles';

function unwrap(res) {
  if (!res?.success) {
    throw new Error(res?.message || 'Erreur API');
  }
  return res.data;
}

function normalizeRole(item) {
  return {
    id: item.id ?? null,
    value: item.value,
    label: item.label,
    badge: item.badge || 'info',
    system: Boolean(item.system),
  };
}

const roleService = {
  async list() {
    const data = unwrap(await apiService.get('/roles'));
    const roles = Array.isArray(data) ? data.map(normalizeRole) : [];
    setRuntimeUserRoles(roles);
    return roles;
  },

  async create({ label, badge = 'info' }) {
    const created = unwrap(await apiService.post('/roles', { label, badge }));
    return normalizeRole(created);
  },

  async update(id, { label, badge }) {
    const payload = {};
    if (label !== undefined) payload.label = label;
    if (badge !== undefined) payload.badge = badge;
    const updated = unwrap(await apiService.put(`/roles/${id}`, payload));
    return normalizeRole(updated);
  },

  async remove(id) {
    unwrap(await apiService.delete(`/roles/${id}`));
  },
};

export default roleService;
